
import { useEffect } from 'react';
import { trackPageView } from '../../utils/analytics';
import Header from './components/Header';
import Story from './components/Story';
import StickyFooterCTA from './components/StickyFooterCTA';
import AboutPageMeta from './page-meta';

export default function AboutPage() {
  useEffect(() => {
    trackPageView('about');
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0a0a0a] to-[#1a1a1a]">
      <AboutPageMeta />
      <Header />
      <Story />
      <StickyFooterCTA />
    </div>
  );
}
